import { Channel, EventType } from "types/working-model";

export function isTownhallChannel(value?: Channel['type']): boolean {
	return value === EventType.Townhall;
}

export function isWebinarChannel(value?: Channel['type']): boolean {
	return value === EventType.Webinar;
}
